//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { IStateWithData } from 'app/initialization/routing/stateHelpers';
import {
  DashboardStateNames,
  dashboardStatesByName,
} from 'app/top-level-states';

export const hasItemAccessByStateName = (
  stateName: DashboardStateNames,
): boolean | undefined => {
  const state: IStateWithData = dashboardStatesByName[stateName];
  return state.data.hasAccess?.();
};
